import { useNavigate, useSearchParams } from 'react-router-dom';

import { SEARCH_PARAMS } from 'constants/search-params';

import { ROUTES } from '../constants/routes';
import { objectToSearchParams, removeEmpty } from '../utils';

const useMainNavigate = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const formId = searchParams.get(SEARCH_PARAMS.CUSTOM_FORM);

  const createParams = (id: string | number) => {
    return objectToSearchParams(
      removeEmpty({
        id,
        [SEARCH_PARAMS.CUSTOM_FORM]: formId,
      }),
    );
  };

  const goToPaymentView = (id: string | number) => {
    navigate(`${ROUTES.PAYMENT}?${createParams(id)}`);
  };

  const goToInvoice = () => {
    navigate(ROUTES.INVOICE);
  };

  const goToPaymentViewcheck = () => {
    navigate(ROUTES.VIEW_CHECK);
  };

  const goToReturnUrl = (returnUrl: string) => {
    if (returnUrl) window.location.href = returnUrl;
  };

  return {
    goToPaymentView,
    goToInvoice,
    goToPaymentViewcheck,
    goToReturnUrl,
  };
};

export { useMainNavigate };
